module.exports = __webpack_public_path__ + "static/spa03-78bfffb33fde42d619e30ab468bf2375.jpg";